<div class="container-fluid">
  <app-steps
    [steps]="steps"
    [stepChange]="onStepChange"
    (stepClick)="clickStep($event)"
  ></app-steps>

  @if (isPeriodoVigente()) {
    <div class="alert alert-info" role="alert">
      <i class="fa fa-info-circle" style="color: rgba(21, 91, 203, 1)"></i>
      <strong>Informação!</strong> Prazo para confirmação de vagas:
      <strong>{{ cicloSelected?.confirmacaoVaga.fimFormatado }} ({{ diasRestantes() }} dias restantes)</strong>
    </div>
  }

  <div class="d-flex justify-content-end mb-2">
    <br-button
      type="button"
      [emphasis]="'secondary'"
      title="Histórico"
      [ariaLabel]="'Histórico da confirmação de vagas'"
      (click)="abrirHistorico()"
    >
      <i class="fa fa-history"></i> Histórico
    </br-button>
  </div>

  <div class="position-relative">
    <app-card-collapse
      [titulo]="'Informações da Vaga'"
      [isCollapsed]="false"
      [enableCollapse]="false"
      class="w-100 h-100 align-items-center justify-content-center"
    >
      <hr />
      <div class="row info-container">
        <div class="col-3">
          <label>Ciclo do Edital</label>
          <span>{{
            cicloSelected
              ? ('00' + cicloSelected.numeroCiclo).slice(-3) + '/' + cicloSelected.anoCiclo
              : '-'
          }}</span>
        </div>
        <div class="col-3">
          <label>Programa</label>
          <span>{{ cicloSelected?.programa?.nome || '-' }}</span>
        </div>
        <div class="col-3">
          <label>Gestor Responsável</label>
          <span>{{ confirmacaoVaga?.usuario?.nome || usuario.nome || '-' }}</span>
        </div>
        <div class="col-3">
          <label>Nível da Vaga</label>
          <span>Municipal</span>
        </div>
        <div class="col-3 mt-4">
          <label>UF</label>
          <span>{{ municipio?.siglaUf || '-' }}</span>
        </div>
        <div class="col-3 mt-4">
          <label>Município</label>
          <span>{{ municipio?.nomeMunicipio || '-' }}</span>
        </div>
        <div class="col-3 mt-4">
          <label>Prazo de Confirmação</label>
          <span>{{ cicloSelected?.confirmacaoVaga?.fimFormatado || '-' }}</span>
        </div>
        <div class="col-3 mt-4">
          <label>IBGE</label>
          <span>{{ municipio?.id || '-' }}</span>
        </div>
      </div>
    </app-card-collapse>
  </div>

  <form [formGroup]="form" novalidate>
    <div class="mt-4">
      @if (currentStep === 1) {
        <app-confirmar-quantidade-vagas-step
          [onConfirmarQuantidades]="onConfirmarQuantidades"
          [onCancel]="onCancel"
          [onSubmitting]="onSubmitting"
          [onModalidadeVagas]="onLoadModalidadeVagas"
          [onPrintCadastroReserva]="onPrintCadastroReserva"
          [onAlterarCadastroReserva]="onAlterarCadastroReserva"
          [form]="formConfirmarQuantidadeVaga"
          [confirmacaoVaga]="confirmacaoVaga"
          [cicloSelected]="cicloSelected"
          [hasCadastroReserva]="hasCadastroReserva"
          [isVagasLoaded]="isVagasLoaded"
        ></app-confirmar-quantidade-vagas-step>
      }
      @if (currentStep === 2) {
        <app-atribuir-ine-step
          [onAtribuirINE]="onAtribuirINE"
          [onStepChange]="onStepChange"
          [onSubmitting]="onSubmitting"
          [cicloSelected]="cicloSelected"
          [confirmacaoVaga]="confirmacaoVaga"
          [form]="formAtribuirINE"
        ></app-atribuir-ine-step>
      }
      @if (currentStep === 3) {
        <app-resumo-confirmacao-step
          [onResumoConfirmacao]="onResumoConfirmacao"
          [onStepChange]="onStepChange"
          [onSubmitting]="onSubmitting"
          [cicloSelected]="cicloSelected"
          [confirmacaoVaga]="confirmacaoVaga"
        ></app-resumo-confirmacao-step>
      }
    </div>
  </form>
</div>
